<script setup lang="ts">
import { computed, onBeforeUnmount } from 'vue';
import { useStore } from "vuex";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import Length from '../../../source/js/shared/models/Geometry/Length';
import ValidationMessage from "@/components/UI/ValidationMessage.vue";
import { endsWithSeparator, limitDecimals } from "@/functions/numbers";
import { addSizeToDataLayer } from "@/functions/analytics";

const $i18n = window.measurementSelectorVariables.i18n;

const store = useStore();
const drillHoleDiameter = computed(() => store.getters.drillHoleDiameter.in_cm() );
const isDrillHoleValid = computed(() => store.getters.isDrillHoleValid);
const drillHoleValidationMessage = computed(() => store.getters.getDrillHoleValidationMessage);
const minimumDrillHoleDiameter = computed(() => store.getters.minimumDrillHoleDiameter );
const minimumDrillHoleDiameterLabel = computed(() => store.getters.minimumDrillHoleDiameterLabel );

function onUpdate( value: string ) {
	if ( ! endsWithSeparator( value ) ) {
		store.commit( `updateDrillHoleDiameter`, Length.from_cm( limitDecimals( value, 1 ) ).in_mm() );
		store.commit( 'updateUsingDefaultDrillHoleDimensions', false );
	}
}

document.addEventListener('focusin', (event) =>
	store.commit('updateFocusedElement', event)
);

onBeforeUnmount(() => {
	document.removeEventListener('focusin', () =>
		store.commit('updateFocusedElement')
	);
});

</script>
<template>
	<div class="measurements-selector__sub-section">
		<dimension-input
			class="drill-hole-input"
			inputRef="drillHoleDiameter"
			id="measurements-drillHoleDiameter"
			name="drillHoleDiameter"
			unit="cm"
			:min="minimumDrillHoleDiameter"
			:label="`${$i18n.drillHoleConfiguration.diameter_drill_hole} (${minimumDrillHoleDiameterLabel})`"
			:invalid="!isDrillHoleValid('drillHoleDiameter')"
			:onBlur="() => addSizeToDataLayer( 'drillHoleDiameter', drillHoleDiameter, 'preset-drill-holes' )"
			v-model="drillHoleDiameter"
			v-on:update:modelValue="onUpdate($event)"
		/>

		<validation-message
			v-if="!isDrillHoleValid('drillHoleDiameter')"
			input-id="drillHoleDiameter"
		>
			{{ drillHoleValidationMessage('drillHoleDiameter') }}
		</validation-message>
	</div>
</template>
